import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

const PublicationUserview = () => {
  const [publications, setPublications] = useState([]); // Ensure it's an array by default
  const [filteredPublications, setFilteredPublications] = useState([]); // Filtered publications based on status
  const [status, setStatus] = useState(""); // Status filter
  const history = useHistory();

  // Fetch publications from backend
  const fetchPublications = async () => {
    const userId = sessionStorage.getItem("userId"); // Get userId from sessionStorage
    if (!userId) {
      console.error("User not logged in");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/publications/user/${userId}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch publications");
      }
      const data = await response.json();
      console.log("Fetched data:", data);
      setPublications(Array.isArray(data) ? data : []); // Handle response data properly
      setFilteredPublications(Array.isArray(data) ? data : []); // Initialize filtered list
    } catch (error) {
      console.error("Error fetching publications:", error);
      setPublications([]); // If there's an error, set publications to an empty array
      setFilteredPublications([]); // Ensure filtered list is empty in case of error
    }
  };

  // Filter publications based on selected status
  const filterPublicationsByStatus = (status) => {
    if (status === "") {
      setFilteredPublications(publications); // Show all publications if no filter is selected
    } else {
      setFilteredPublications(
        publications.filter((publication) => publication.status === status)
      );
    }
  };

  useEffect(() => {
    fetchPublications(); // Fetch all publications when the component mounts
  }, []); // Only run once on mount

  useEffect(() => {
    // Only apply filtering after publications are fetched
    if (publications.length > 0) {
      filterPublicationsByStatus(status);
    }
  }, [status, publications]);

  const handleSelectPublication = (publication) => {
    // Navigate to the Edit page and pass the publication details as state
    history.push(`/edit/${publication.id}`, { state: { publication } });
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value); // Update status when the user selects a new option
  };

  // Function to get the status color
  const getStatusColor = (status) => {
    switch (status) {
      case "0":
        return "bg-warning text-dark"; // Unapproved (orange mixed with yellow)
      case "1":
        return "bg-success text-white"; // Approved (green)
      case "2":
        return "bg-danger text-white"; // Archived (red)
      default:
        return ""; // No color if status is empty or undefined
    }
  };

  return (
    <div className="container my-4">
      <h1 className="text-center mb-4">Publication List</h1>

      {/* Filter by Status */}
      <div className="mb-3 text-end">
        <label htmlFor="status" className="form-label me-2">
          Filter by Status:
        </label>
        <select
          id="status"
          className="form-select d-inline-block w-auto"
          value={status}
          onChange={handleStatusChange}
        >
          <option value="">All</option>
          <option value="0">UnApproved</option>
          <option value="1">Approved</option>
          <option value="2">Archived</option>
        </select>
      </div>

      {/* Publications Table */}
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Pub ID</th>
              <th>TITLE</th>
              <th>Indexing</th>
              <th>Publication</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredPublications.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center">
                  No publications available.
                </td>
              </tr>
            ) : (
              filteredPublications.map((publication) => (
                <tr key={publication.id}>
                  <td>{publication.id}</td>
                  <td style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                    {publication.title}
                  </td>
                  <td style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                    {publication.indexing}
                  </td>
                  <td style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                    {publication.publication}
                  </td>
                  <td>
                    <span className={`badge ${getStatusColor(publication.status)}`}>
                      {publication.status === "0"
                        ? "UnApproved"
                        : publication.status === "1"
                        ? "Approved"
                        : "Archived"}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PublicationUserview;
